module.exports = __webpack_public_path__ + "img/revenues-Charging.d952850f.png";